export default __webpack_public_path__ + "static/media/1927.bdf7c0ad.png";